import { render, staticRenderFns } from "./ListPriceForm.vue?vue&type=template&id=ed2cde50"
import script from "./ListPriceForm.vue?vue&type=script&lang=js"
export * from "./ListPriceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports